// home/YourInfra.jsx — now "Resource Hub" section
import React from 'react';
import { FileText, Play } from 'lucide-react';

const resources = [
  {
    type: 'Whitepaper',
    icon: FileText,
    title: 'The Death of Passive Surveillance: A Guide to the Dark SOC',
    body: 'Learn how leading security organizations are eliminating reactive monitoring and building fully autonomous operations.',
    cta: 'Download the Whitepaper',
    accentBorder: 'border-t-primary',
  },
  {
    type: 'Video',
    icon: Play,
    title: 'Watch: Multi-Modal AI vs. Standard Motion Detection',
    body: 'A side-by-side demonstration of how Kinetic Guard\'s intelligence layer outperforms traditional motion-based alerting in a live environment.',
    cta: 'Watch the Demo',
    accentBorder: 'border-t-accent-orange',
  },
];

export function YourInfra() {
  const handleResourceClick = (resource) => {
    console.log('Resource requested:', resource.title);
    alert('Coming soon — take the audit above to be notified when this resource is available.');
  };

  return (
    <div id="resources" className="py-16 md:py-24 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-base text-primary font-semibold tracking-wide uppercase">Knowledge Base</h2>
          <p className="mt-2 text-3xl leading-8 font-bold tracking-tight text-foreground sm:text-4xl" style={{ fontFamily: "'Outfit', sans-serif" }}>
            From Passive Surveillance to the Dark SOC
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {resources.map((resource) => {
            const Icon = resource.icon;
            return (
              <div key={resource.title} className={`bg-card border border-border border-t-4 ${resource.accentBorder} rounded-lg overflow-hidden`}>
                {/* Mock visual area */}
                <div className="bg-muted/50 aspect-video relative flex items-center justify-center">
                  <Icon className="h-16 w-16 text-muted-foreground/30" />
                </div>
                <div className="p-6">
                  <span className="text-xs font-bold uppercase tracking-widest text-accent-orange bg-accent-orange/10 px-3 py-1 rounded-full">
                    {resource.type}
                  </span>
                  <h3 className="mt-4 text-lg font-semibold text-foreground" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    {resource.title}
                  </h3>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                    {resource.body}
                  </p>
                  <button
                    onClick={() => handleResourceClick(resource)}
                    className="mt-4 text-sm font-medium text-primary hover:text-primary/80 transition-colors"
                  >
                    {resource.cta} &rarr;
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
